// Ocean ve Air dashboard'ları aynı bileşenleri kullanır; mod farkları burada tutulur
import CrudService from "services/cruds-service";

export const TRANSPORT_MODES = {
    ocean: {
        title: "Ocean Operations Control Tower",
        hflLabel: "House Files (OHFL)",
        mblLabel: "Master Files (OMBL)",
        terms: { carrier: "Shipping Line", vessel: "Vessel", line: "Line" },
        hfl: {
            prefix: "OHFL",
            fetch: () => CrudService.getOceanShipments(),
            editPath: "/shipping-order/create-ocean-shipment/details",
            typeField: "oceanTransportType",
            showType: true,
        },
        mbl: {
            label: "OMBL",
            fetch: () => CrudService.getOMBLs(),
            numberField: "omblNumber",
            editPath: "/ocean-shipping-order/connect-ombl",
            freightKey: "oceanFreight",
        },
    },
    air: {
        title: "Air Operations Control Tower",
        hflLabel: "House Files (AHFL)",
        mblLabel: "Master Files (AMBL)",
        terms: { carrier: "Airline", vessel: "Flight", line: "Airline" },
        hfl: {
            prefix: "AHFL",
            fetch: () => CrudService.getAirShipments(),
            editPath: "/shipping-order/create-air-shipment/details",
            typeField: "airTransportType",
            showType: false,
        },
        mbl: {
            label: "AMBL",
            fetch: () => CrudService.getAMBLs(),
            numberField: "amblNumber",
            editPath: "/air-shipping-order/connect-ambl",
            freightKey: "airFreight",
        },
    },
};
